import { useCallback } from "react";
import { Textarea } from "@/components/ui/textarea";
import { slotRegistry, type SlotEditorProps } from "../slot_registry.js";

function TextSlotEditor({ content, update }: SlotEditorProps) {
  const text = new TextDecoder().decode(content);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newContent = new TextEncoder().encode(e.target.value);
      update(newContent);
    },
    [update],
  );

  return (
    <Textarea
      value={text}
      onChange={handleChange}
      placeholder="Enter text content..."
      rows={6}
      className="w-full"
    />
  );
}

slotRegistry.register({
  type: "text",
  component: TextSlotEditor,
});
